import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-zero-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})

export class TableComponent implements OnInit {
  @Input() headers: any = []
  @Input() items: any = []

  @Output() messageEvent = new EventEmitter<string>();

  sortField: string
  sortBy: string = 'asc' || 'desc'

  ngOnInit() {
    
  }

  onSort(field: string) {
    console.log(field)
  }
}